import './EntityCollectionField.scss';
import EntitySelectModal from './EntitySelectModal';
import Entity from './Entity';
import React from 'react';
import ReactDOM from 'react-dom';
import {
  SortableContainer as sortableContainer,
  SortableElement as sortableElement,
  arrayMove
} from 'react-sortable-hoc';

class EntityListItem extends React.Component {
  render() {
    return (
      <li className="contentful-entity-list-item">
        <Entity
          entity={this.props.entity}
          disabled={this.props.disabled}
          onRemove={this.props.onRemove}
          aspect={1}
          showIcon={false}
          allowEdit={this.props.allowEdit}
        />
      </li>
    );
  }
}

EntityListItem.defaultProps = {
  entity: null,
  index: null,
  allowEdit: false
};

const SortableEntityListItem = sortableElement(EntityListItem);

class EntityList extends React.Component {
  constructor(props) {
    super(props);

    this.activeItem = null;
  }

  render() {
    return (
      <div className="contentful-entity-collection-wrapper">
        <ul className="list-unstyled">
          {this.props.items.map(this.renderItem.bind(this))}
        </ul>
      </div>
    );
  }

  renderItem(entity, index) {
    // Make sure we store a reference back to the item at the active index:
    const active = index === this.props.activeIndex;
    const props = {
      key: `item-${index}-${entity.id}`,
      index: index,
      entity: entity,
      onRemove: () => {
        this.props.onRemove(index);
      },
      disabled: this.props.disabled,
      allowEdit: this.props.allowEdit
    };

    if (active) {
      props.ref = (element) => {
        this.activeItem = element;
      };
    }

    return (
      <SortableEntityListItem {...props} />
    );
  }

  componentDidUpdate(prevProps) {
    // Check whether the active index changed and we need to scroll a new item
    // into view:
    if (this.props.activeIndex !== prevProps.activeIndex &&
        this.activeItem
    ) {
      // Look up the actual DOM node from the SortableEntityListItem
      // component instance.
      const element = ReactDOM.findDOMNode(this.activeItem); // eslint-disable-line react/no-find-dom-node

      element.scrollIntoView({
        block: 'start',
        behavior: 'smooth'
      });
    }
  }
}

EntityList.defaultProps = {
  items: null,
  onRemove: () => {}
};

const SortableEntityList = sortableContainer(EntityList);

class EntityCollectionField extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      uploading: false,
      selecting: false,
      activeIndex: 0
    };

    this.handleSortEnd = this.handleSortEnd.bind(this);
    this.handleToggleSelector = this.handleToggleSelector.bind(this);
    this.handleRemove = this.handleRemove.bind(this);
    this.handleSelection = this.handleSelection.bind(this);
    this.handleClear = this.handleClear.bind(this);
  }

  handleSortEnd({oldIndex, newIndex}) {
    if (!this.props.disabled) {
      const newValue = arrayMove(this.props.value, oldIndex, newIndex);
      this.props.onChange(this.props.name, newValue, 'sort');
    }
  }

  handleToggleSelector() {
    if (!this.props.disabled) {
      this.setState({
        selecting: !this.state.selecting
      });
    }
  }

  handleRemove(removedIndex) {
    if (!this.props.disabled) {
      const newValue = [].concat(this.props.value);
      newValue.splice(removedIndex, 1);
      this.props.onChange(this.props.name, newValue, 'remove');
    }
  }

  handleSelection(selection) {
    if (!this.props.disabled) {
      const newValue = this.props.value.concat([selection]);
      try {
        this.props.onChange(this.props.name, newValue, 'add');
        this.setState({
          selecting: !!this.props.quickAdd, // Keep selecting if quickAdd, else close selecting
          activeIndex: newValue.length - 1
        });
      } catch (error) {
        // If we hit an error, close the modal. This is to provide the onChange function an escape hatch if needed.
        this.setState({
          selecting: false
        });
      }
    }
  }

  handleClear() {
    if (!this.props.disabled) {
      const newValue = [];
      this.props.onChange(this.props.name, newValue, 'clear');
      this.setState({
        selecting: false,
        activeIndex: 0
      });
    }
  }

  render() {
    return (
      <div className={`${this.props.disabled ? 'disabled ' : ''}contentful-entity-collection-field`}>
        {Boolean(this.props.value.length) &&
          <SortableEntityList
            axis="x"
            lockAxis="x"
            items={this.props.value}
            onSortEnd={this.handleSortEnd}
            onRemove={this.handleRemove}
            helperClass="contentful-entity-list-item-sortable-helper"
            activeIndex={this.state.activeIndex}
            pressDelay={400}
            disabled={this.props.disabled}
            allowEdit={this.props.allowEdit}
          />
        }
        {!this.props.value.length &&
          <div className="contentful-entity-collection-empty well h4">
            Ingen entiteter valgt.
          </div>
        }
        <p className="text-left">
          <a
            className={`${(this.state.selecting ? 'active ' : '') + (this.props.disabled ? 'disabled ' : '')}btn btn-default`}
            onClick={this.handleToggleSelector}
          >
            <i className="fa fa-plus" aria-hidden="true"></i> Legg til
          </a>
          &nbsp;
          {this.props.removeAllButton &&
            <a
              className={`${(this.props.disabled ? 'disabled ' : '')}btn btn-danger`}
              onClick={this.handleClear}
            >
              <i className="fa fa-minus" aria-hidden="true"></i> Fjern all publisering
            </a>
          }
          {/* &nbsp;
          <a
            className={(this.props.disabled ? 'disabled ' : '') + 'btn btn-default'}
            onClick={this.handleUpload}
          >
            {this.state.uploading &&
              <span><i className="fa fa-spinner fa-pulse fa-fw"></i> Laster opp...</span>
            }
            {!this.state.uploading &&
              <span><i className="fa fa-cloud-upload" aria-hidden="true"></i> Last opp</span>
            }
          </a>*/}
        </p>

        <EntitySelectModal
          show={this.state.selecting}
          onSelect={this.handleSelection}
          onHide={this.handleToggleSelector}
          contentType={this.props.contentType}
          searcher={this.props.searcher}
          searchParams={this.props.searchParams}
          searchFilterFn={this.props.searchFilterFn}
          showArchived={this.props.showArchived}
          searchOnOpen={this.props.searchOnOpen}
          quickAdd={this.props.quickAdd}
        />
      </div>
    );
  }
}

EntityCollectionField.defaultProps = {
  value: [],
  name: 'entity',
  disabled: false,
  onChange: () => {},
  allowEdit: false
};

export default EntityCollectionField;
